import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{attrs:{"cols":"12","md":"3"}},[_c(VSelect,{staticClass:"input-activation",attrs:{"items":_vm.plates,"label":"Veículo","item-text":"plate","return-object":"","required":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }